module.exports = __webpack_public_path__ + "assets/beta-avax.304c3d36.svg";